import { useEffect, useState } from 'react';
import { Typography, Grid, Box } from '@mui/material';
import BrushIcon from '@mui/icons-material/Brush';
import FenceIcon from '@mui/icons-material/Fence';
import PlumbingIcon from '@mui/icons-material/Plumbing';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import HandymanIcon from '@mui/icons-material/Handyman';
import {
    ServicesContainer,
    ServiceCard,
    ServiceIcon,
    ServiceContent,
} from './Services.styles';
import axios from 'axios';

const IconMap = {
    brush: <BrushIcon fontSize="large" />,
    fence: <FenceIcon fontSize="large" />,
    plumbing: <PlumbingIcon fontSize="large" />,
    homeRepair: <HomeRepairServiceIcon fontSize="large" />,
    cleaning: <CleaningServicesIcon fontSize="large" />,
    handyman: <HandymanIcon fontSize="large" />,
};

const backendUrl =
    import.meta.env.MODE === 'development'
        ? `http://${import.meta.env.VITE_BACKEND_URL}`
        : `https://${import.meta.env.VITE_BACKEND_URL_PROD}`;

const Services = () => {
    const [services, setServices] = useState([]);

    useEffect(() => {
        const fetchServices = async () => {
            const response = await axios.get(`${backendUrl}/services`);
            setServices(response.data);
        };
        fetchServices();
    }, []);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                height: 'auto',
                py: { xs: 8, md: 12 },
            }}
        >
            <ServicesContainer id="services">
                <Box sx={{ textAlign: 'center', mb: 6 }}>
                    <Typography
                        variant="h2"
                        component="h2"
                        align="center"
                        color="text.primary"
                        sx={{ fontWeight: 600, mb: 0 }}
                    >
                        Our Services
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        sx={{
                            fontWeight: 600,
                        }}
                    >
                        CCB #253480 - licensed, bonded and insured
                    </Typography>
                </Box>

                <Typography
                    variant="h5"
                    align="center"
                    color="text.secondary"
                    sx={{ mb: 8, maxWidth: '800px', mx: 'auto' }}
                >
                    We offer a wide range of professional handyman services to
                    meet all your home maintenance and improvement needs.
                </Typography>

                <Grid container spacing={4}>
                    {services.map((service, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <ServiceCard>
                                <ServiceIcon>
                                    {IconMap[service.icon]}
                                </ServiceIcon>
                                <ServiceContent>
                                    <Typography
                                        variant="h5"
                                        component="h3"
                                        gutterBottom
                                        color="text.primary"
                                    >
                                        {service.title}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        color="text.secondary"
                                    >
                                        {service.description}
                                    </Typography>
                                </ServiceContent>
                            </ServiceCard>
                        </Grid>
                    ))}
                </Grid>

                <Box sx={{ textAlign: 'center', mt: 8 }}>
                    <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ fontStyle: 'italic' }}
                    >
                        Don't see what you need? Contact us anyway - we handle
                        many other types of projects!
                    </Typography>
                </Box>
            </ServicesContainer>
        </Box>
    );
};

export default Services;
